import _ from 'underscore';
import { track } from 'util/analytics';
import { $body, jqGetElemById, $window } from 'util/global';
import { EVT_QUIZ_POSITION_DID_CHANGE } from 'util/constants';
import { modalController } from 'util/ui';
import { BEvents } from './events';


/**
 * Shows the streak notification, mobile only
 * @param {JQuery} $modal
 */
export function streakNotif($modal) {
    // use defer to be extra sure that the elements we're looking for exist on the page
    _.defer(() => {
        // don't show the modal if the user just leveled up or finished a skill
        if (jqGetElemById('sales-card').length === 0) {
            $modal.show();

            _.defer(() => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                $modal.addClass('animated');
            });

            // hide streak modal after viewing another problem/pane
            $body.one(EVT_QUIZ_POSITION_DID_CHANGE, () => {
                $modal.one('transitionend', () => {
                    $modal.hide();
                });
                $modal.removeClass('animated');
            });
        }
    });
}


/**
 * Controller.
 * @param {JQuery} $container
 */
export function continuePracticing($container) {
    const data = $container.data();
    const eventParams = {
        action: 'click',
        element_type: 'button',
        continue_practicing_quiz_id: data.targetQuizId,
        continue_practicing_lesson_id: data.targetLessonId,
        continue_practicing_problems_left: data.problemsLeft,
        path: window.location.pathname,
        full_path: window.location.pathname + window.location.search,
    };

    // push front chat above continue practicing
    const $footerNotifs = jqGetElemById('footer-notifs');
    const footerNotifsHeight = $footerNotifs.outerHeight();
    const containerHeight = $container.outerHeight();
    $footerNotifs.css('height', footerNotifsHeight + containerHeight + 20);

    // handle continue practicing click
    $container.find('.continue-practicing-button').on('click', () => {
        track('ui', _.extend({
            element_id: 'continue_practicing_button',
        }, eventParams));
    });

    // handle dismiss click
    const $dismissForm = $container.find('form');
    const $dismissBtn = $dismissForm.find('.close');
    $dismissBtn.on('click', () => {
        $container.hide();
        $footerNotifs.css('height', footerNotifsHeight);
        track('ui', _.extend({
            element_id: 'continue_practicing_dismissed',
        }, eventParams));
    });
}


/**
 * Show tooltip on header premium button after canceling
 * @param {JQuery} $container
 */
export function reenablePremium($container) {
    setTimeout(() => {
        $container.addClass('in');
        track('ui', {
            element_id: 'autorenewcancel_show_tooltip',
        });
    }, 1000);

    const hideTooltip = () => {
        $container.one('transitionend', $container.remove);
        $container.removeClass('in');
    };

    $container.on('click', e => e.stopPropagation());
    $container.find('.btn-close').one('click', hideTooltip);
    $body.on('click', hideTooltip);
}

export function help($container) {
    $container.find('a').on('click', () => {
        track('ui', {
            element_id: 'clicked_help_hamburger_menu',
        });
    });
}

export function viewReferralHistoryModal($modal) {
    modalController($modal);

    $window.on('ReferralHistoryModal.close', () => {
        $modal.modal('hide');
    });

    $window.on(BEvents.notificationsLoaded.name, () => {
        $body.find("a[href$='#view-referral-history-trigger-btn']").on('click', (e) => {
            e.preventDefault();
            $modal.modal('show');
        });
    });
}

export function viewReferAFriendModal($modal) {
    modalController($modal);

    $window.on('ReferAFriendModal.close', () => {
        $modal.modal('hide');
    });

    $window.on('ReferAFriendModal.cta-clicked', () => {
        window.location.href = '/referral';
    });
}
